export default __webpack_public_path__ + "static/high-performance-networks-74bb2557349ea3e497b2dd7de74b4647.svg";